/*
  قاعدة رقم/رمز أمر العمل (تُفرض في الخادم لكل طرق الإنشاء — WorkOrderNumberRule):
    ① لا يتكرر نفس (رقم أمر العمل + رمز أمر العمل).
    ② نفس الرقم مرتان على الأكثر في النظام كله، وبرمزين مختلفين.
  الواجهة تعرض نتيجة الخادم Toast صغيرة فقط (من مُعترِضات api/apiClient.js لكل الشاشات):
    - رفض: الرد 409 مع code = WO_DUPLICATE_CODE | WO_NUMBER_LIMIT.
    - قبول للمرة الثانية برمز مختلف: ترويسة X-WorkOrder-Rule: WO_SECOND_CODE;count=n.
  الشاشة التي ترى isWorkOrderRuleError(err) لا تفتح نافذة خطأ كبيرة (الرسالة ظهرت Toast).
*/
import { toast } from "./toast";

export const WO_RULE = {
  DUPLICATE: "WO_DUPLICATE_CODE",
  LIMIT: "WO_NUMBER_LIMIT",
  SECOND: "WO_SECOND_CODE",
  MAX_PER_NUMBER: 2,
  MSG_DUPLICATE: "أمر العمل مسجل مسبقًا بنفس الرمز.",
  MSG_LIMIT: "لا يمكن الإضافة، الحد الأقصى لتكرار رقم أمر العمل هو مرتان.",
  MSG_SECOND: "تمت إضافة أمر العمل بنجاح برمز مختلف.",
  HEADER: "x-workorder-rule",
};

/** رمز رفض القاعدة من خطأ axios أو جسم رد (أو null). */
export function workOrderRuleCode(errOrBody) {
  const body = errOrBody?.response?.data ?? errOrBody;
  if (!body || typeof body !== "object") return null;
  if (body.code === WO_RULE.DUPLICATE || body.code === WO_RULE.LIMIT) return body.code;
  const texts = [body.message, body.error, body.Message, ...(Array.isArray(body.errors) ? body.errors.map((e) => e?.message ?? e) : [])];
  if (texts.includes(WO_RULE.MSG_DUPLICATE)) return WO_RULE.DUPLICATE;
  if (texts.includes(WO_RULE.MSG_LIMIT)) return WO_RULE.LIMIT;
  return null;
}

export const isWorkOrderRuleError = (err) => Boolean(err?.asfWorkOrderRule || workOrderRuleCode(err));

/** Toast رفض القاعدة برمزها (للفحص المسبق في الواجهة قبل الإرسال). */
export function toastWorkOrderRule(code) {
  if (code === WO_RULE.DUPLICATE) toast.error(WO_RULE.MSG_DUPLICATE, { id: "wo-rule" });
  else if (code === WO_RULE.LIMIT) toast.warning(WO_RULE.MSG_LIMIT, { id: "wo-rule" });
  else return false;
  return true;
}

/** يعرض Toast الرفض مرة واحدة لكل خطأ ويعلّمه. */
export function announceWorkOrderRuleError(err) {
  const code = workOrderRuleCode(err);
  if (!code) return false;
  if (err && typeof err === "object") {
    if (err.asfWorkOrderRule) return true;
    err.asfWorkOrderRule = code;
  }
  if (code === WO_RULE.DUPLICATE) toast.error(WO_RULE.MSG_DUPLICATE, { id: "wo-rule" });
  else toast.warning(WO_RULE.MSG_LIMIT, { id: "wo-rule" });
  return true;
}

/** قبول الرقم للمرة الثانية برمز مختلف (من ترويسة الرد) ← Toast نجاح. */
export function announceWorkOrderRuleResponse(response) {
  const raw = response?.headers?.[WO_RULE.HEADER] || response?.headers?.get?.(WO_RULE.HEADER);
  if (!raw || !String(raw).startsWith(WO_RULE.SECOND)) return false;
  const n = Number((String(raw).match(/count=(\d+)/) || [])[1] || 1);
  toast.success(n > 1 ? `${WO_RULE.MSG_SECOND} (${n})` : WO_RULE.MSG_SECOND, { id: "wo-rule" });
  return true;
}
